export abstract class Environment {
    abstract readonly production: boolean;
    abstract readonly development: boolean;
    abstract readonly api: {
        baseURL: string;
    };
    abstract readonly firebase: {
        readonly apiKey: string;
        readonly authDomain: string;
        readonly databaseURL: string;
        readonly projectId: string;
        readonly storageBucket: string;
        readonly messagingSenderId: string;
        readonly appId: string;
        readonly backofficeURL: string;
    };
}
